import { useForm } from '@inertiajs/react'
import { Settings } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import type { Copy, Publication } from '@/frontend/features/DashboardRuntime/types'

export default function PublicationAccess({ publication, path, viewers, copy }: {
  publication: Publication; path: string; viewers: { id: number; name: string }[]; copy: Copy
}) {
  const current = { publication: { visibility: publication.visibility },
    viewer_ids: publication.access?.viewer_ids ?? [], access_revision: publication.access?.revision ?? null }
  const form = useForm(current)
  const stale = !publication.access || form.data.access_revision !== publication.access.revision
  return <Popover>
    <PopoverTrigger asChild>
      <Button type="button" variant="ghost" size="icon" className="shrink-0 text-muted-foreground" aria-label={copy.access} title={copy.access}>
        <Settings className="size-4" aria-hidden />
      </Button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-80 max-w-[calc(100vw-2rem)]" aria-label={copy.access}>
    <form className="space-y-4" onSubmit={(event) => { event.preventDefault(); if (!stale) form.patch(path) }}>
      <h2 className="text-sm font-semibold">{copy.access}</h2>
      {stale && <div role="alert" className="space-y-2 rounded-md bg-muted p-3 text-sm">
        <p>{copy.access_changed}</p>
        <Button type="button" variant="outline" size="sm" onClick={() => form.setData(current)}>{copy.reload_access}</Button>
      </div>}
      <select className="w-full rounded border p-2" aria-label={copy.access} value={form.data.publication.visibility}
        onChange={(event) => form.setData('publication', { visibility: event.target.value as Publication['visibility'] })}>
        <option value="restricted">{copy.restricted}</option><option value="organization">{copy.organization}</option>
      </select>
      <div className="max-h-64 space-y-2 overflow-y-auto">{viewers.map((viewer) => <label key={viewer.id} className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={form.data.viewer_ids.includes(viewer.id)} onChange={(event) => form.setData('viewer_ids', event.target.checked
          ? [...form.data.viewer_ids, viewer.id] : form.data.viewer_ids.filter((id) => id !== viewer.id))} />{viewer.name}
      </label>)}</div>
      <button className="w-full rounded bg-primary px-3 py-2 text-primary-foreground disabled:opacity-50" disabled={form.processing || stale}>{copy.save}</button>
    </form>
    </PopoverContent>
  </Popover>
}
